function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";export const ExplorationContentOverviewContainer=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${props=>props.theme.colors.neutral900};
`;export const OverviewRow=props=>{return React.createElement(FlexLayout,_extends({flexDirection:"row",justifyContent:"flex-start",flexWrap:"wrap",alignItems:"flex-start",alignContent:"flex-start",itemsSpacingVertical:8,occupyParentWidth:true},props),props.children)};export const OverviewRowContentBlock=props=>{return React.createElement(FlexLayout,_extends({},props,{flex:"1 0 33%",maxWidth:"33%"}),props.children)};export const StyledBlockContentContainer=styled(FlexLayout)`
  color: ${props=>props.theme.colors.neutral800};

  div:first-of-type {
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
  }

  div:last-child {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }
`;export const BlockContent=props=>{return React.createElement(StyledBlockContentContainer,_extends({flexDirection:"column",justifyContent:"center",flexWrap:"nowrap",alignItems:"center",alignContent:"center",textAlign:"center",equalWidthItems:true},props),props.children)};export const OverviewSecondarySectionContainer=props=>{return React.createElement(FlexLayout,_extends({flexDirection:"column",flexWrap:"nowrap",justifyContent:"flex-start",alignItems:"stretch",occupyParentWidth:true,equalWidthItems:true},props),props.children)};export const ExplorationContentSubTitle=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: flex-start;
  color: ${props=>props.theme.colors.neutral900};
`;